import $ from '../../core/KJQuery'
import _ from 'lodash'

const style = {
  display: 'block',
  visibility: 'hidden',
  position: 'absolute',
  top: 0,
  left: 0,
  height: '100%',
  width: '100%',
  overflow: 'hidden',
  pointerEvents: 'none',
  zIndex: -1,
}

export default {
  name: 'KResizeAware',
  data() {
    return {
      // resizeTarget: null,
      width: null,
      height: null,
    }
  },
  mounted() {
    this.$refs.resizeElement.data = 'about:blank'
  },
  beforeDestroy() {
    const isListener = this.resizeTarget && typeof this.resizeTarget.removeEventListener === 'function'

    isListener && this.resizeTarget.removeEventListener('resize', this.handleResize)
  },
  methods: {
    onResizeElementLoaded() {
      const ref = this.$refs.resizeElement
      this.resizeTarget = ref.contentWindow
      this.$nextTick(() => {
        $(this.resizeTarget).on('resize', this.handleResize)
        this.handleResize()
      })
    },
    handleResize() {
      const sizes = {
        width: $(this.resizeTarget).outerWidth(),
        height: $(this.resizeTarget).outerHeight(),
      }
      _.assign(this, sizes)

      this.$emit('resize', sizes)
    },
  },
  render(createElement) {
    return createElement('object', {
      style,
      attrs: {
        type: 'text/html',
        'aria-hidden': true,
        tabIndex: -1,
      },
      on: {
        load: this.onResizeElementLoaded,
      },
      ref: 'resizeElement',
    })
  },
}
